<template>
  <v-btn v-bind="$attrs" variant="outlined" elevation="2" :class="IF.MyFont">
    <slot></slot>
  </v-btn>
</template>

<script>
export default {};
</script>

<style>
</style>